'use strict';

import { USER } from '../constants/ActionTypes';

const initialGlobalState = {
  MINI_CART: false,
  MINI_CART_NUM : null,
  ErrorCode: false,
  USER_SHIPPING_ADDRESS_LIST: false,
  USER_TYPE: false,
  USER_POINT: false,

  USER_TOKEN: false,
  USER_NICKNAME: false,
  USER_CARDTYPE: false,
  USER_CARDPOINTS: false,
  USER_CARDNUMBER: false,
  USER_PAYPOINTS: false
};

export default function (state = initialGlobalState, action = {}) {
  let MINI_CART = action.MINI_CART;
  let MINI_CART_NUM = action.MINI_CART_NUM;
  let ErrorCode = action.ERROR_CODE;
  let USER_SHIPPING_ADDRESS_LIST = action.USER_SHIPPING_ADDRESS_LIST;
  let USER_POINT = action.USER_POINT;

  let USER_TOKEN = action.USER_TOKEN;
  let USER_NICKNAME = action.USER_NICKNAME;
  let USER_CARDTYPE = action.USER_CARDTYPE;
  let USER_CARDPOINTS = action.USER_CARDPOINTS;
  let USER_CARDNUMBER = action.USER_CARDNUMBER;
  let USER_PAYPOINTS = action.USER_PAYPOINTS;
  let USER_TYPE = action.USER_TYPE;


  switch (action.type) {
    case USER.USER_TOKEN:
      return Object.assign({},state,{
        USER_TOKEN
      });
    case USER.USER_NICKNAME:
      return Object.assign({},state,{
        USER_NICKNAME
      });
    case USER.USER_CARDTYPE:
      return Object.assign({},state,{
        USER_CARDTYPE
      });
    case USER.USER_CARDPOINTS:
      return Object.assign({},state,{
        USER_CARDPOINTS
      });
    case USER.USER_CARDNUMBER:
      return Object.assign({},state,{
        USER_CARDNUMBER
      });
    case USER.USER_PAYPOINTS:
      return Object.assign({},state,{
        USER_PAYPOINTS
      });
    case USER.USER_ID:
      return Object.assign({}, state, {
        USER_TYPE,
        USER_POINT
      });
    case USER.ERROR_CODE:
      return Object.assign({}, state, {
        ErrorCode
      });
    case USER.MINI_CART:
      return Object.assign({}, state, {
        MINI_CART
      });
    case USER.MINI_CART_NUM:
      return Object.assign({}, state, {
        MINI_CART_NUM
      });
    case USER.USER_SHIPPING_ADDRESS_LIST:
      return Object.assign({}, state, {
        USER_SHIPPING_ADDRESS_LIST
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./common/reducers/user.js